import { PasswordPolicy } from "@/modules/login/models/state";

/** Login **/

export interface LoginRequestData {
  user: string;
  password: string;
  remember: boolean;
}

export interface LoginResponseData {
  msg?: string;
  status: Status;
  "failed-login-timeout-min"?: number;
  "password-policy"?: PasswordPolicy;
}

/** Change Password **/

export interface ChangePasswordRequestData {
  username: string;
  old_password: string;
  new_password: string;
  verify_password: string;
}

export interface ChangePasswordResponseData {
  status: Status;
}

/** Status **/

export enum Status {
  Idle = "IDLE",
  Ok = "OK",
  Deactivated = "DEACTIVATED",
  PermanentlyLocked = "PERMANENTLY_LOCKED",

  // Login
  Locked = "LOCKED",
  PasswordExpired = "PASSWORD_EXPIRED",
  Failed = "FAILED",

  // Change Password
  "PasswordsDiffer" = "PASSWORDS_DIFFER",
  "WeakPassword" = "WEAK_PASSWORD",
  "WrongPassword" = "WRONG_PASSWORD",
  "PasswordSimilarToOld" = "PASSWORD_SIMILAR_TO_OLD",
  "UnknownError" = "UNKNOWN_ERROR",
}

/** Errors **/

export const statusErrorMap: { [status: string]: string } = {
  DEACTIVATED: "login.status_errors.deactivated",
  PERMANENTLY_LOCKED: "login.status_errors.permanently_locked",
  LOCKED:"login.status_errors.user_locked",

  // Login
  FAILED: "login.status_errors.login_failed",

  // Change Password
  PASSWORDS_DIFFER: "login.status_errors.passwords_differ",
  WEAK_PASSWORD: "login.status_errors.weak_password",
  WRONG_PASSWORD: "login.status_errors.wrong_password",
  PASSWORD_SIMILAR_TO_OLD: "login.status_errors.password_similar_to_old",
  UNKNOWN_ERROR: "login.status_errors.unknown_error",
};
